import { Chip, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import RetornoVistaRegimental from './RetornoVistaRegimental';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';

class IconesMagistradosProcesso extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            relatorOriginario: computed,
            mostrarRedator: computed,
            redatorDiferenteRelator: computed,
            titularOJ: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get relatorOriginario() {
        return {
            sigla: this.registro.informacoesAdicionais.relatorOriginario,
            nome: this.registro.informacoesAdicionais.nomeRelatorOriginario
        };
    }

    get mostrarRedator() {
        return this.parametroStore.isOrgaoTST
            ? this.redatorDiferenteRelator && this.processo?.redator?.sigla
            : SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(this.registro.resultadoJulgamento);
    }

    get redatorDiferenteRelator() {
        const relator = this.relatorOriginario?.sigla ? this.relatorOriginario : this.processo.relator;
        return (
            this.processo.redator &&
            this.processo.redator.sigla &&
            relator &&
            this.processo.redator.sigla &&
            this.processo.redator.sigla !== relator.sigla
        );
    }

    get titularOJ() {
        return this.processo.relator && this.processo.relator.titularOJ !== false;
    }

    render() {
        const titularOuSubstituto = this.titularOJ ? ' (Titular do OJ)' : ' (Substituto(a) do OJ)';

        return (
            <div
                data-expand
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div
                    data-expand
                    style={{ minWidth: '66px' }}
                >
                    {this.renderRelator()}
                </div>
                <div
                    data-expand
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        margin: this.observableProps.espacamentoReduzido ? '0px' : '0px 4px',
                        justifyContent: 'center'
                    }}
                >
                    {this.mostrarRedator && (
                        <Tooltip
                            placement="top"
                            title={
                                <Typography>
                                    Redator(a): {this.processo.redator.nome} {titularOuSubstituto}
                                </Typography>
                            }
                        >
                            <Chip
                                label={this.processo.redator.sigla || '<Pendente no ' + this.processo.origem + '>'}
                                style={{
                                    height: '24px',
                                    color: this.titularOJ ? 'black' : 'rgb(183, 28, 28)',
                                    fontSize: 12,
                                    borderWidth: '4px',
                                    borderStyle: 'solid',
                                    borderColor: '#b5b5b5'
                                }}
                            />
                        </Tooltip>
                    )}
                </div>
                <div
                    data-expand
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        margin: this.observableProps.espacamentoReduzido ? '0px' : '0px 4px',
                        justifyContent: 'center'
                    }}
                >
                    {this.processo.revisor && (
                        <Tooltip title={<Typography>Revisor(a): {this.processo.revisor.nome}</Typography>}>
                            <Chip
                                label={this.processo.revisor.sigla}
                                style={{
                                    height: '24px',
                                    color: this.titularOJ ? 'black' : 'rgb(183, 28, 28)',
                                    fontSize: 12,
                                    borderWidth: '4px',
                                    borderStyle: 'solid',
                                    borderColor: 'gray'
                                }}
                            />
                        </Tooltip>
                    )}
                </div>
                <div
                    data-expand
                    style={{ minWidth: this.observableProps.dense ? '0px' : 'auto' }}
                >
                    <RetornoVistaRegimental registro={this.registro} />
                </div>
            </div>
        );
    }

    renderRelator() {
        if (!this.processo.relator) {
            return null;
        }

        const titularOuSubstituto = this.titularOJ ? '(Titular do OJ)' : '(Substituto(a) do OJ)';

        const titleRelator = this.relatorOriginario.sigla
            ? `Relator(a) originário: ${this.relatorOriginario.nome}`
            : `Relator(a): ${this.processo.relator.nome} ${titularOuSubstituto}`;

        return (
            <Tooltip title={<Typography>{titleRelator}</Typography>}>
                <Chip
                    label={
                        this.relatorOriginario.sigla ||
                        this.processo.relator.sigla ||
                        '<Pendente no ' + this.processo.origem + '>'
                    }
                    style={{
                        height: '24px',
                        color: this.titularOJ ? 'black' : 'rgb(183, 28, 28)',
                        fontSize: 12
                    }}
                />
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(IconesMagistradosProcesso));
